/* Angular Stuff*/
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

/* Our Own Stuff*/
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
  selector: 'app-bank-list',
  templateUrl: './../../../templates/forms/modals/new-company-list.component.html',
})
export class NewCompanyListComponent implements OnInit {
  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "NewCompanyListId"

  employeeList:any[] = [];
  public searchString;
  constructor(private dataService: DataLoadService,
    public langService: LangService,
    public gridService:GridService) { 
      this.colObj = [
        { headerName: langService.langData.submenuId, field: 'SUBMENU_ID', sortable: true, resizable: true, hide: false },
        { headerName: langService.langData.reportsName, field: 'SUBMENU_NAME_USER', sortable: true, resizable: true, hide: false },
        { headerName: langService.langData.description, field: 'DESCR', sortable: true, resizable: true, hide: false },
      ];
    }

  ngOnInit() {  
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId); 
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataService.load('FG_HR1137_SUBMENU').subscribe(results=>{
      this.employeeList = results.body;
    })
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

} 